export default {
	stage: 'prd',
	studentApiBaseUrl: 'https://studentapi.prtl.co',
	wishlistServiceBaseUrl: 'https://decisionmakingapi.prtl.co',
	tokenServiceBaseUrl: 'https://tokens.prtl.co',
	wssEndpoint: 'wss://studentwebsocketservice.prtl.co/v1',
	PUBLIC_ROLLBAR_TOKEN: 'd597d60d3a464048a2576b8529714d8f39a2694110351372e360a12a5a9900edba5d3e2988931b484194f226080ea5d7',
	ANONYMOUS_STUDENT_ROLLBAR_TOKEN: 'ef1caa400c9946809e9807efb891d8085ac1b4ed91e37911f7ca42f961ee89d5f3b73c32749a417054b76f3fcdee174f'
};
